module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '/**\n * States of Chemical Species\n *\n * Can\'t wait for ECMA 6\n */\ndefine(function () {\n    var instance = null;\n    function SpecieState() {\n        this.LIQUID = "l";\n        this.SOLID = "s";\n        this.GAS = "g";\n        this.AQUEOUS = "aq";\n    }\n    SpecieState.getInstance = function() {\n        if(instance === null) {\n            instance = new SpecieState();\n        }\n        return instance;\n    };\n    return SpecieState.getInstance();\n});\n';

}
return __p
}